import {
  MultiSelectProps,
  MultiSelect as PrimeMultiSelect,
} from '@agro1desenvolvimento/react-components';
import { classNames } from 'primereact/utils';
import WithController from '../with-controller';
import InputEnhancements, { FormInputEnhancements } from './input-enhancements';

const MIN_LENGTH_TO_SHOW_SEARCH = 5;

const MultiSelect = WithController<PropTypes, any>(
  ({
    field,
    fieldState,
    addonRight,
    addonLeft,
    label,
    withErrorMessage,
    containerClassName,
    formState: _formState,
    className,
    onChange,
    triggerDependencies,
    visible = true,
    options,
    dataKey,
    optionLabel,
    optionValue,
    placeholder,
    ...props
  }) => {
    const onChangeValue = (e: any) => {
      field.onChange(e.value);

      if (onChange) onChange(e);

      triggerDependencies();
    };

    return (
      <InputEnhancements
        addonRight={addonRight}
        addonLeft={addonLeft}
        label={label}
        withErrorMessage={withErrorMessage}
        containerClassName={containerClassName}
        field={field}
        fieldState={fieldState}
        visible={visible}
      >
        <PrimeMultiSelect
          filter={(options?.length || 0) > MIN_LENGTH_TO_SHOW_SEARCH}
          {...props}
          id={field.name}
          name={field.name}
          ref={field.ref}
          value={field.value}
          onBlur={field.onBlur}
          onChange={onChangeValue}
          className={classNames({ 'p-invalid': fieldState.error }, className)}
          options={options}
          dataKey={dataKey}
          optionLabel={optionLabel}
          optionValue={optionValue}
          placeholder={placeholder}
        />
      </InputEnhancements>
    );
  },
);

type OmittedProps =
  | 'id'
  | 'name'
  | 'ref'
  | 'value'
  | 'onBlur'
  | 'onValueChange';

type PropTypes = Omit<MultiSelectProps, OmittedProps> & FormInputEnhancements;

export default MultiSelect;
